/** @typedef {import('../../shell/types/user.types.js').AuthApiResponse} AuthApiResponse */
/** @typedef {import('../../shell/types/user.types.js').AuthViewModel} AuthViewModel */

/**
 * @param {AuthApiResponse} apiResponse
 * @returns {AuthViewModel}
 */
export function toAuthViewModel(apiResponse) {
  return {
    token: apiResponse.token,
    email: apiResponse.email,
    clientSlug: apiResponse.clientSlug,
    clientName: apiResponse.clientName,
    domain: apiResponse.domain,
  };
}

/**
 * @param {{ email: string, password: string }} formData
 * @returns {{ email: string, password: string }}
 */
export function toLoginRequest(formData) {
  return {
    email: formData.email.trim().toLowerCase(),
    password: formData.password,
  };
}

/**
 * @param {{ email: string, password: string, clientSlug: string, userCreationGuid: string }} formData
 * @returns {{ email: string, password: string, clientSlug: string, userCreationGuid: string }}
 */
export function toRegisterRequest(formData) {
  return {
    email: formData.email.trim().toLowerCase(),
    password: formData.password,
    clientSlug: formData.clientSlug.trim().toLowerCase(),
    userCreationGuid: (formData.userCreationGuid || '').trim(),
  };
}
